/*  MUI  */
import { Typography } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

// Both impact and status expect a lowercase string.

export const StyledIncidentImpact = ({
    incidentImpact,
    isResolved = false
}) => {
    const { t } = useTranslation();
    return (
        <Typography
            sx={{
                ...(!isResolved
                    ? {
                          color: `externalAppStatus.${incidentImpact}`,
                          fontWeight: 600
                      }
                    : {})
            }}
        >
            {t(`Applications.incidentImpact.${incidentImpact}`) || '-'}
        </Typography>
    );
};

export const StyledIncidentStatus = ({
    incidentStatus,
    isResolved = false
}) => {
    const { t } = useTranslation();
    return (
        <Typography
            sx={{
                ...(isResolved
                    ? {
                          color: `externalAppStatus.${incidentStatus}`,
                          fontWeight: 600
                      }
                    : {})
            }}
        >
            {t(`Applications.incidentStatus.${incidentStatus}`) || '-'}
        </Typography>
    );
};
